function initSwipeGallery(carousel) {
  const items = carousel.querySelectorAll('.product-gallery__media');
  if (!items.length) return;

  let startX = 0;
  let isDown = false;
  let currentIndex = 0;

  const scrollToIndex = (i) => {
    const item = items[i];
    if (!item) return;

    carousel.scrollTo({
      left: item.offsetLeft,
      behavior: 'smooth'
    });
  };

  carousel.addEventListener('pointerdown', (e) => {
    isDown = true;
    startX = e.clientX;
    carousel.setPointerCapture(e.pointerId);
  });

  carousel.addEventListener('pointerup', (e) => {
    if (!isDown) return;
    isDown = false;

    const diff = e.clientX - startX;

    // 👇 关键：拖动阈值
    if (Math.abs(diff) > 60) {
      if (diff < 0) {
        currentIndex = Math.min(currentIndex + 1, items.length - 1);
      } else {
        currentIndex = Math.max(currentIndex - 1, 0);
      }
    }

    scrollToIndex(currentIndex);
  });

  carousel.addEventListener('pointercancel', () => {
    isDown = false;
  });
}

// init
document.querySelectorAll('media-carousel').forEach(initSwipeGallery);



  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form.matches('.product-upsell-form')) return;
      const title = form.querySelector('.product-upsell-item__title');
      const price = form.querySelector('.product-upsell-item__price');
      const btn = form.querySelector('.product-upsell-btn');
      if (title) {
        title.textContent = 'Adding...';
      }
      if (price) {
        price.style.display = 'none';
      }
      if (btn) {
        btn.disabled = true;
      }
    },
    true
  );
  document.addEventListener('variant:add', (event) => {
    const form = event.target.closest('form');
    if (!form || !form.matches('.product-upsell-form')) return;
    const wrapper = form.closest('.product-upsell-item__wrapper');
    const title = form.querySelector('.product-upsell-item__title');
    const btn = form.querySelector('.product-upsell-btn');
    if (wrapper) {
      wrapper.classList.add('product-upsell-item__wrapper--added');
    }
    if (title) {
      title.textContent = 'Added to cart';
    }
    if (btn) {
      btn.remove();
    }
  });
  document.addEventListener('cart:error', (event) => {
    const form = event.target.closest('form');
    if (!form || !form.matches('.product-upsell-form')) return;
    const title = form.querySelector('.product-upsell-item__title');
    const price = form.querySelector('.product-upsell-item__price');
    const btn = form.querySelector('.product-upsell-btn');
    if (title) {
      title.textContent = 'Failed';
    }
    if (price) {
      price.style.display = '';
    }
    if (btn) {
      btn.disabled = false;
    }
  });

